export default __webpack_public_path__ + "static/spiralblade-098e935f553474332bec2eb0a1a50aa8.png";